import React, { useState } from "react";
import { Table, Button, Modal, Form, Spinner, Alert, InputGroup } from "react-bootstrap";
import ModalConfirmar from "../../components/ModalConfirmar";
import * as gastosComunesApi from "../../api/gastosComunes";
import { formatoNumero } from "../../utils/moneda";

/** Pestaña de "Familia Gastos" solo para el Jefe: administra el catálogo de gastos comunes
 * propio de su familia (antes vivía en Mantenimiento y lo manejaba el Administrador). El aporte
 * de cada miembro se pone en la pestaña "Proyección", no acá. */
export default function GastosComunesTab({ items, onCambio }) {
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [aEliminar, setAEliminar] = useState(null);
  const [form, setForm] = useState({ nombre: "", montoPrincipal: "", orden: 0 });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const abrir = (g) => {
    setError("");
    setEditando(g);
    setForm(g ? { nombre: g.nombre, montoPrincipal: g.montoPrincipal, orden: g.orden } : { nombre: "", montoPrincipal: "", orden: items.length });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await gastosComunesApi.upsertGastoComun({
        gastoComunId: editando?.gastoComunId ?? null,
        nombre: form.nombre,
        montoPrincipal: Number(form.montoPrincipal || 0),
        orden: Number(form.orden || 0),
      });
      setShowModal(false);
      onCambio();
    } finally {
      setGuardando(false);
    }
  };

  const confirmarEliminar = async () => {
    try {
      await gastosComunesApi.eliminarGastoComun(aEliminar.gastoComunId);
      setAEliminar(null);
      onCambio();
    } catch (err) {
      setAEliminar(null);
      setError(err.response?.data?.mensaje || "No se pudo eliminar el gasto común.");
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-end mb-2 mt-3">
        <Button size="sm" variant="outline-primary" onClick={() => abrir(null)}>
          <i className="bi bi-plus-lg me-1"></i>Nuevo gasto común
        </Button>
      </div>

      {error && <Alert variant="danger" dismissible onClose={() => setError("")}>{error}</Alert>}

      <div className="fs-card p-0 overflow-hidden">
        <Table responsive hover className="table-fs table-fs-responsive mb-0 align-middle">
          <thead><tr><th>Nombre</th><th className="text-end">Monto principal</th><th></th></tr></thead>
          <tbody>
            {items.map((g) => (
              <tr key={g.gastoComunId}>
                <td data-label="Nombre">{g.nombre}</td>
                <td data-label="Monto principal" className="text-end fw-semibold">${formatoNumero(g.montoPrincipal)}</td>
                <td data-label="Acciones" className="text-end">
                  <Button size="sm" variant="outline-primary" className="me-1" onClick={() => abrir(g)}><i className="bi bi-pencil"></i></Button>
                  <Button size="sm" variant="outline-danger" onClick={() => setAEliminar(g)}><i className="bi bi-trash"></i></Button>
                </td>
              </tr>
            ))}
            {!items.length && (
              <tr><td colSpan={3} className="text-center text-muted py-4">No hay gastos comunes registrados.</td></tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton><Modal.Title style={{ fontSize: "1.1rem" }}>{editando ? "Editar gasto común" : "Nuevo gasto común"}</Modal.Title></Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required autoFocus placeholder="Ej. Alquiler, Luz, Comida..." />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Monto principal</Form.Label>
              <InputGroup>
                <InputGroup.Text>$</InputGroup.Text>
                <Form.Control type="number" step="0.01" min="0" value={form.montoPrincipal} onChange={(e) => setForm({ ...form, montoPrincipal: e.target.value })} required />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <Form.Label>Orden</Form.Label>
              <Form.Control type="number" value={form.orden} onChange={(e) => setForm({ ...form, orden: e.target.value })} />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
            <Button type="submit" variant="primary" disabled={guardando}>{guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <ModalConfirmar show={!!aEliminar} titulo="Eliminar gasto común" mensaje={`¿Eliminar "${aEliminar?.nombre}"?`}
        onConfirmar={confirmarEliminar} onCancelar={() => setAEliminar(null)} />
    </div>
  );
}
